import React from "react";
import { Grid, Box } from "@material-ui/core";

import Modal from "app/components/modals/Modal";
import CobeeButton from "app/components/CobeeButton";
import { redirect } from "app/routes/Routes";
import { translate as t } from "infrastructure/translate/localization";
import { updateEmployeesStatus } from "usecases/employee-detail/restore-employees";
import { displayEmployeesPage } from "usecases/employees/displays/display-employees-page";

type RestoreEmployeesModalProps = {
  employeesIds: string[];
  setIsOpen: (value: boolean) => void;
};

function RestoreEmployeesModal({
  employeesIds,
  ...rest
}: RestoreEmployeesModalProps) {
  const handleEmployeesStatus = async () => {
    const employees = employeesIds.map((id) => ({
      employeeId: id,
    }));

    try {
      await updateEmployeesStatus({ employees });
      await displayEmployeesPage();
      redirect("/employees");
    } catch (error) {
      //
    } finally {
      rest.setIsOpen(false);
    }
  };

  return (
    <Modal {...rest} title={t("employees-section.restore-modal.title")}>
      <div>
        <p>{t("employees-section.restore-modal.message")}</p>

        <Box pt={4}>
          <Grid container justifyContent="flex-end">
            <CobeeButton size="large" onClick={() => handleEmployeesStatus()}>
              {t("actions.continue")}
            </CobeeButton>
          </Grid>
        </Box>
      </div>
    </Modal>
  );
}

export default RestoreEmployeesModal;
